export const HOME_LOGIN_POPUP_PENDING_KEY = 'home_login_popup_pending'

export function markHomeLoginPopupPending() {
  sessionStorage.setItem(HOME_LOGIN_POPUP_PENDING_KEY, '1')
}

export function consumeHomeLoginPopupPending() {
  const pending = sessionStorage.getItem(HOME_LOGIN_POPUP_PENDING_KEY) === '1'
  if (pending) {
    sessionStorage.removeItem(HOME_LOGIN_POPUP_PENDING_KEY)
  }
  return pending
}
